<template>
  <v-row>
    <v-col cols="12">
      <v-sheet 
        class="image-sheet d-flex align-center justify-center"
        :style="{ backgroundImage: 'url(' + my_project_image + ')' }"
        outlined
        min-height="85vh">
        
        <v-row class="mt-8 mb-8">
          
          <v-col cols="12" xl="4" md="4" sm="12" class="text-center">
            <v-btn 
              text
              dark
              outlined
              :to="{name: 'myStartUp'}"
              height="240px">
              <v-img 
                max-width="220px"
                max-height="220px"
                :src="my_project_info_button">
              </v-img>
            </v-btn>
          </v-col>

          <v-col cols="12" xl="4" md="4" sm="12" class="text-center">
            <v-btn 
              text
              dark
              outlined
              :to="{name: 'myEntrepreneurialTeam'}"
              height="240px">
              <v-img 
                max-width="220px"
                max-height="220px"
                :src="my_project_up_team_button">
              </v-img>
            </v-btn>
          </v-col>

          <v-col cols="12" xl="4" md="4" sm="12" class="text-center">
            <v-btn 
              text
              dark
              outlined
              :to="{name: 'myWindow'}"
              height="240px">
              <v-img 
                max-width="220px"
                max-height="220px"
                :src="my_project_up_stand_button">
              </v-img>
            </v-btn>
          </v-col>

        </v-row>
      </v-sheet>
    </v-col>

  </v-row>
</template>

<script>
  const APP_URL = process.env.VUE_APP_URL
  import axios from 'axios'
  import { mapGetters } from 'vuex'

  export default {
    name: 'myEntrepreneurship',

    data: () => ({
      loading:true,
      state_convocation_form:'',
      
      my_project_image: null,
      my_project_info_button: null,
      my_project_up_team_button: null,
      my_project_up_stand_button: null,


    }),
    computed: {
      ...mapGetters([ 
          'convocation_form', 'edition'
      ])
    },
    methods:{
      async getStatus(){
        await axios.get('convocation/status/'+this.convocation_form.convocation_form.id).then((response) =>{
          this.state_convocation_form=response.data.status;
          this.loading=false;
        }).catch(error => {
          console.log(error);
        })
      },

      setData(){
      this.my_project_image = APP_URL + this.edition.edition.edition_customization.my_project_image

      this.my_project_info_button = APP_URL + this.edition.edition.edition_customization.my_project_info_button
      this.my_project_up_team_button = APP_URL + this.edition.edition.edition_customization.my_project_up_team_button
      this.my_project_up_stand_button = APP_URL + this.edition.edition.edition_customization.my_project_up_stand_button
    }
    },

    created(){
      Promise.all([
        this.setData(),
        this.getStatus()
      ]).then(() => {
        this.loading=false
      }).catch((error) => {
        console.log(error)
      });
    }
  }
</script>
<style scoped>
.image-sheet {
  background-size: cover;
  min-height: 100dvh;
}

.image-overlay{
  position: absolute;
  top: 0;
  left: 0;
  width: auto;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}
</style>